module.exports = __webpack_public_path__ + "static/media/cy-xiaoya-qrcode.fd4d6046.png";